import React, { useContext } from "react";
import styled, { css } from "styled-components";
import OnColorContext from "../../../contexts/OnColorContext";
import breakpoint from "../../../utils/breakpoint";
import getBorderColor from "../../../utils/getBorderColor";
import isNotEmpty from "../../../utils/isNotEmpty";
import space from "../../../utils/space";
import unit from "../../../utils/unit";
import BreakpointVisibilityOrg from "../../organisms/BreakpointVisibilityOrg";
import FlexContainerOrg from "../../organisms/FlexContainerOrg";
import FlexItemOrg from "../../organisms/FlexItemOrg";
import PushOrg from "../../organisms/PushOrg";
import SurfaceOrg from "../../organisms/SurfaceOrg";
export var Wrapper = styled.div.withConfig({
  componentId: "sc-pad7sc-0"
})(function (_ref) {
  var $onColor = _ref.$onColor,
    theme = _ref.theme,
    $hasFullWidth = _ref.$hasFullWidth;
  return css(["", ""], !$hasFullWidth ? css(["", "{padding-right:", ";border-right:", " solid ", ";}"], breakpoint("medium"), space(3), unit(1), getBorderColor(theme, $onColor, "extraLow")) : null);
});
export var Container = styled.div.withConfig({
  componentId: "sc-pad7sc-1"
})(function (_ref2) {
  var $hasFullWidth = _ref2.$hasFullWidth;
  return css(["", ""], $hasFullWidth ? css(["width:100%;"]) : css(["width:100%;max-width:", ";", "{max-width:", ";}", "{max-width:100%;text-align:center;}"], space(30.5), breakpoint("medium", "large"), space(24.5), breakpoint("small", "medium")));
});
function BundlePromoBoxMol(_ref3) {
  var text = _ref3.text,
    icon = _ref3.icon,
    hasFullWidth = _ref3.hasFullWidth;
  var onColor = useContext(OnColorContext);
  return /*#__PURE__*/React.createElement(Wrapper, {
    $onColor: onColor,
    $hasFullWidth: hasFullWidth
  }, /*#__PURE__*/React.createElement(Container, {
    $hasFullWidth: hasFullWidth
  }, /*#__PURE__*/React.createElement(SurfaceOrg, {
    spacingSpace: {
      small: {
        vertical: 1.5,
        horizontal: 2.5
      },
      medium: {
        vertical: 2.5,
        horizontal: 2
      },
      large: 2
    },
    color: "background",
    borderRadiusSize: {
      small: "none",
      medium: "large",
      large: "large",
      huge: "large"
    }
  }, /*#__PURE__*/React.createElement(FlexContainerOrg, {
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(FlexItemOrg, {
    flexBasis: 0,
    flexGrow: 1,
    flexShrink: 1
  }, text), isNotEmpty(icon) ? /*#__PURE__*/React.createElement(BreakpointVisibilityOrg, {
    from: "large"
  }, /*#__PURE__*/React.createElement(PushOrg, {
    leftUnit: 10
  }, icon)) : null))));
}
export default BundlePromoBoxMol;